import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {ProjectComponent} from 'app/modules/project/components/project/project.component';

import {routes as featureModuleRoutes} from 'app/modules/features/features.routing';
import {routes as projectModuleRoutes} from 'app/modules/project/project.routing';
import {routes as modelEditorRoutes} from "@catmodules/model-editor/model-editor.routing";

import {GlobalConfigResolve} from '@catapp/modules/base-app/services/global-config.resolve';
import {FeaturesComponent} from 'app/modules/features/components/features/features.component';
import {ContentContainerComponent} from './components/content-container/content-container.component';

/**
 * A list of all the routings in the  {@link AppModule}
 * @type {{path: string; component: ContentContainerComponent; resolve: {globalConfig: GlobalConfigResolve}; children: ({path: string; redirectTo: string; pathMatch: string} | {path: string; component: ProjectComponent; children: Routes} | {path: string; component: FeaturesComponent; children: Routes} | {path: string; component: ResourceContainerComponent; children: Routes} | {path: string; children: Routes})[]}[]}
 */
export const appRoutes: Routes = [
  {
    path: '',
    component: ContentContainerComponent,
    resolve: {
      globalConfig: GlobalConfigResolve,
    },
    children: [
      {
        path: '',
        redirectTo: '/projects',
        pathMatch: 'full',
      },
      {
        path: 'projects',
        component: ProjectComponent,
        children: projectModuleRoutes,
      },
      {
        path: 'features',
        component: FeaturesComponent,
        children: featureModuleRoutes,
      },
      {
        path: 'model-editor',
        children: modelEditorRoutes
      }
    ],
  },

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/base-app/app.routing.ts